import { mimeTypes } from "@mobsuccess-devops/react-shared/utils/mime-types";

import type { MediaFile } from "./media-file";

export function isMediaType<
  T extends
    | "image/*"
    | "video/*"
    | "zip/*"
    | "audio/*"
    | "dco/video"
    | "dco/static"
    | "youtube/video",
>(
  asset: MediaFile,
  prefix: T,
): asset is T extends "image/*"
  ? Extract<MediaFile, { type: `image/${string}` }>
  : T extends "video/*"
    ? Extract<MediaFile, { type: `video/${string}` }>
    : T extends "zip/*"
      ? Extract<MediaFile, { type: `application/${string}zip${string}` }>
      : T extends "audio/*"
        ? Extract<MediaFile, { type: `audio/${string}` }>
        : Extract<MediaFile, { type: T }> {
  if (!("type" in asset)) {
    return false;
  }
  switch (prefix) {
    case "image/*":
      return asset.type.startsWith("image/");
    case "video/*":
      return asset.type.startsWith("video/");
    case "audio/*":
      return asset.type.startsWith("audio/");
    case "zip/*":
      return mimeTypes.zip().includes(asset.type);
    case "dco/video":
      return asset.type === "dco/video";
    case "dco/static":
      return asset.type === "dco/static";
    case "youtube/video":
      return asset.type === "youtube/video";
    default:
      return false;
  }
}
